define('areas/navigationmanager/commands/createnavigationnodecommand',["require", "exports"], function (require, exports) {
    "use strict";
    var CreateNavigationNodeCommand = (function () {
        function CreateNavigationNodeCommand(process) {
            this._createNode = process;
        }
        CreateNavigationNodeCommand.prototype.execute = function (symbol) {
            this._createNode.process(symbol);
        };
        return CreateNavigationNodeCommand;
    }());
    return CreateNavigationNodeCommand;
});

